import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'
const equipRouter: RouteConfig = {
  path: '/ratsheetManage',
  redirect: 'noredirect',
  name: 'ratsheetManage',
  component: Layout,
  children: [
    {
      path: 'ratsheetManage',
      component: () => import('@/views/ratsheetManage/index.vue'),
      name: 'ratsheetManage',
      meta: {
        title: '评估标准管理',
        icon: 'resource',
        requireAuth: true,
      }
    },
  ]

}

export default equipRouter
